import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import { IsTenantReadyGuard } from '@app/guards/is-tenant-ready/is-tenant-ready.guard';

export const isTenantReadyGuard: CanActivateChildFn = () => inject(IsTenantReadyGuard).isTenantReady();
